export enum PATHS {
    COMING_SOON='/comingSoon',
    CONTACT='/contact',
    COLLABORATION_PLATFORM ='/collaborationPlatform',
	DEMO='/demo',
    DEMO_PLATFORM='/comingSoon',
    HOME='/',
}